









































































































































































import Vue from "vue";
import { Terminal } from "xterm";
import { AttachAddon } from "xterm-addon-attach";
// import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";
import { Header } from "../../MyTable.vue";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { axios } from "@/plugins";

const headers: Header[] = [
  { title: "Pod名称", width: 200 },
  { title: "容器名称", width: 200 },
  { title: "镜像", width: 300 },
  { title: "端口", width: 200 },
  { title: "状态", width: 120 },
  { title: "重启次数", width: 100 },
  { title: "运行时间", width: 200 },
  { title: "操作", width: 80 }
];

export default Vue.extend({
  name: "Container",
  props: {
    data: { type: Object },
    type: { type: String },
    projectId: { type: String }
  },
  data() {
    return {
      headers,
      loadType: "",
      showLog: false,
      timer: 0,
      viewMode: "TAILLINES",
      connectParam: "100",
      viewOptions: ["TAILF", "TAILLINES", "GREP"],
      showShell: false,
      ws: (null as any) as WebSocket,
      term: (null as any) as Terminal,
      // 翻页禁止参数
      disabled: false,
      // 查询日志的数据
      logData: {
        namespace: "",
        projectId: "",
        podName: "",
        container: "",
        viewMode: "",
        connectParam: ""
      }
    };
  },
  computed: {
    ...mapState("PrjAppCom/Log", [
      "total",
      "hasNext",
      "pageNum",
      "logs",
      "loading",
      "hasMore",
      "wsRuning"
    ]),
    ...mapGetters("PrjAppCom/Log", ["tableData"])
  },
  mounted() {
    this.getTable();
  },
  beforeDestroy() {
    this.closeAll();
    this.clearLogs();
  },
  methods: {
    refush() {
      this.clear();
      this.clearLogs();
      this.getTable();
      if (this.showLog) {
        this.logConnect(this.logData.viewMode);
      }
    },
    ...mapActions("PrjAppCom/Log", [
      "getData",
      "pageTurn",
      "clear",
      "init",
      "close",
      "connect",
      "nextPage",
      "wsInit",
      "wsStop",
      "downloadLogs"
    ]),
    ...mapMutations("PrjAppCom/Log", { clearLogs: "CLEAR_LOG" }),
    getTable() {
      if (this.type === "无状态组件") {
        this.loadType = "Deployment";
      } else if (this.type === "有状态组件") {
        this.loadType = "StatefulSet";
      }
      this.getData({
        url: "/pod/container/list/project",
        append: `&projectId=${this.projectId}&loadType=${this.loadType}&app=${this.data.metadata.name}`
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    handleCommand(
      type: "log" | "shell" | "upload" | "podDownload" | "delete",
      data: any
    ) {
      this[type](data);
    },
    delete(data: any) {
      this.$confirms({
        title: `删除 ${data.podName}`,
        message: "删除后将自动重启，您确定要删除吗？"
      }).then(() => {
        axios
          .delete(
            `/pod/project?name=${data.podName}&projectId=${this.projectId}`
          )
          .then(() => {
            this.$message.success("容器删除成功");
            this.$emit("refush");
          });
      });
    },
    connectParamChange(val: string) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (val) {
          this.connect({ logData: this.logData, el: this.$refs.logs });
        }
      }, 300);
    },
    log(data: any) {
      this.showLog = true;
      this.logData = {
        namespace: data.namespace,
        projectId: this.projectId,
        podName: data.podName,
        container: data.containerName,
        viewMode: this.viewMode,
        connectParam: this.connectParam
      };
      this.$nextTick(() => {
        this.init({ logData: this.logData, el: this.$refs.logs });
      });
    },
    logConnect(val: string) {
      if (val === "TAILLINES") {
        this.logData.connectParam = "100";
      } else {
        this.logData.connectParam = "";
      }
      if (val !== "GREP") {
        this.connect({ logData: this.logData, el: this.$refs.logs });
      }
    },
    logNextPage() {
      this.nextPage(this.$refs.logs);
    },
    getHeightLight(data: string) {
      if (this.logData.viewMode === "GREP" && this.logData.connectParam) {
        const reg = new RegExp(this.logData.connectParam, "gi");
        return data
          .replace("<", "&lt;")
          .replace(">", "&gt;")
          .replace(reg, str => `<b>${str}</b>`);
      }
      return data;
    },
    shell(data: any) {
      this.showShell = true;
      // const fitAddon = new FitAddon();
      this.$nextTick(() => {
        const { height } = (document.querySelector(
          "#shell"
        ) as HTMLElement).getBoundingClientRect();

        this.term = new Terminal({
          lineHeight: 1.2,
          fontSize: 14,
          cols: 80,
          rows: Math.floor(height / 19)
        });
        // this.term.loadAddon(fitAddon);

        // setTimeout(() => {
        //   fitAddon.fit();
        // });
        // 本地调试 ws 端口 location 计算
        let url = "wss://gavialstone.mlogcn.com";
        // 线上 ws 端口，根据
        if (process.env.NODE_ENV === "production") {
          url = `${location.protocol === "http:" ? "ws" : "wss"}://${
            location.host
          }`;
        }
        this.ws = new WebSocket(
          `${url}/ws/shell?projectId=${this.projectId}&pod=${data.podName}&container=${data.containerName}`
        );

        this.term.loadAddon(new AttachAddon(this.ws));
        this.term.open(document.querySelector("#shell") as HTMLElement);

        // fitAddon.fit();

        setTimeout(() => {
          this.term.focus();
        }, 0);
      });
    },
    shellBoxClick() {
      this.term && this.term.focus();
    },
    download() {
      this.downloadLogs(
        `container=${this.logData.container}&pod=${this.logData.podName}&namespace=${this.logData.namespace}`
      );
    },
    upload(data: any) {
      (this.$refs.upload as any).show({
        url: "/pod/file/upload/project",
        form: {
          projectId: this.projectId,
          pod: data.podName,
          container: data.containerName
        }
      });
    },
    podDownload(data: any) {
      (this.$refs.download as any).show(
        `/pod/file/download/project?projectId=${this.projectId}&pod=${data.podName}&container=${data.containerName}&path=`
      );
    },
    closeAll() {
      this.showLog = false;
      this.showShell = false;
      this.close();
      this.clearLogs();
      this.term && this.term.dispose();
      this.ws && this.ws.close();
    }
  }
});
